export default __webpack_public_path__ + "static/media/ArrowDown.cd737607.svg";